// sofortdiagnostik.js
document.addEventListener('DOMContentLoaded', () => {
  const testCategories = [
    {
      category: "Tumordiagnostik",
      tests: [
        { name: "UBC qualitativ", profit: 8.74 },
        { name: "UBC quantitativ", profit: 14.69 },
        { name: "ScheBo® 2in1 Quick", profit: 18.55 },
        { name: "ScheBo® M2-PK Quick", profit: 9.16 },
        { name: "fPSA", profit: 12.37 },
        { name: "PSA", profit: 13.56 },
        { name: "HPV", profit: 22.09 }
      ]
    },
    {
      category: "Hormondiagnostik",
      tests: [
        { name: "Vitamin D", profit: 13.62 },
        { name: "TSH", profit: 7.83 },
        { name: "Anti-Müller-Hormon (FIA)", profit: 31.23 },
        { name: "fT3 (FIA)", profit: 7.24 },
        { name: "fT4 (FIA)", profit: 7.24 },
        { name: "Prolaktin (FIA)", profit: 13.94 },
        { name: "Testosteron (FIA)", profit: 12.75 }
      ]
    },
    {
      category: "Infektionsdiagnostik",
      tests: [
        { name: "CRP", profit: 5.08 },
        { name: "PCT", profit: 27.07 },
        { name: "NeoPT", profit: 26.48 },
        { name: "Urin System Chrom", profit: 57.29 }
      ]
    },
    {
      category: "Kardiale Diagnostik",
      tests: [
        { name: "sPLA2-IIA", profit: 19.64 }
      ]
    },
    {
      category: "Magen-Darm-Diagnostik",
      tests: [
        { name: "GastroPanel Quick Test", profit: 54.55 }
      ]
    },
    {
      category: "Andere Marker",
      tests: [
        { name: "HbA1c", profit: 7.46 },
        { name: "Homocystein", profit: 13.13 }
      ]
    }
  ];

  let selectedTests = [];

  function renderAvailableTests() {
    const container = document.getElementById('availableTests_2025');
    if (!container) return;
    container.innerHTML = '';

    testCategories.forEach(category => {
      const categoryTitle = document.createElement('div');
      categoryTitle.classList.add('test-category_2025');
      categoryTitle.textContent = category.category;
      container.appendChild(categoryTitle);

      category.tests.forEach(test => {
        const div = document.createElement('div');
        div.classList.add('available-test_2025');

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = `test-${test.name}_2025`;
        checkbox.style.width = '20px';
        checkbox.style.height = '20px';
        checkbox.style.accentColor = '#2c7c8c';
        checkbox.addEventListener('change', () => toggleTestSelection(test, checkbox.checked));

        const label = document.createElement('label');
        label.htmlFor = `test-${test.name}_2025`;
        label.textContent = test.name;
        label.style.marginLeft = '10px';

        div.appendChild(checkbox);
        div.appendChild(label);
        container.appendChild(div);

        // Checkbox-Status
        if (selectedTests.some(t => t.name === test.name)) {
          checkbox.checked = true;
        }
      });
    });
  }

  function toggleTestSelection(test, isChecked) {
    if (isChecked) {
      if (!selectedTests.some(t => t.name === test.name)) {
        selectedTests.push({ ...test, count: 0 });
      }
    } else {
      selectedTests = selectedTests.filter(t => t.name !== test.name);
    }
    renderSelectedTests();
    updateCalculations();
  }

  function renderSelectedTests() {
    const container = document.getElementById('selectedTests_2025');
    if (!container) return;
    container.innerHTML = '';

    selectedTests.forEach((test, index) => {
      const div = document.createElement('div');
      div.classList.add('test-row_2025');
      div.innerHTML = `
        <span class="test-name_2025">${test.name}</span>
        <input type="number" class="test-input_2025" min="0" value="${test.count}">
        <span class="test-result_2025">€${(test.count * test.profit).toFixed(2)}</span>
        <span class="test-label_2025">Gewinn/Woche</span>
      `;
      const inputField = div.querySelector('.test-input_2025');
      inputField.addEventListener('change', (e) => updateTestValue(index, e.target.value));
      container.appendChild(div);
    });
  }

  function updateTestValue(index, value) {
    selectedTests[index].count = parseInt(value) || 0;
    renderSelectedTests();
    updateCalculations();
  }

  function updateCalculations() {
    let totalTests = 0;
    let totalProfit = 0;

    selectedTests.forEach(test => {
      totalTests += test.count;
      totalProfit += test.count * test.profit;
    });

    const totalTestsEl = document.getElementById('totalTests_2025');
    const weeklyProfitEl = document.getElementById('weeklyProfit_2025');
    const monthlyProfitEl = document.getElementById('monthlyProfit_2025');
    const yearlyProfitEl = document.getElementById('yearlyProfit_2025');

    if (totalTestsEl) totalTestsEl.textContent = totalTests;
    if (weeklyProfitEl) weeklyProfitEl.textContent = '€' + totalProfit.toFixed(2);
    if (monthlyProfitEl) monthlyProfitEl.textContent = '€' + (totalProfit * 4).toFixed(2);
    if (yearlyProfitEl) yearlyProfitEl.textContent = '€' + (totalProfit * 52).toFixed(2);
  }

  // Initiales Rendering
  renderAvailableTests();
  renderSelectedTests();
});